var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPhone = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M11.54 11.54C9.56 13.5 7.27 15.4 6.36 14.5c-1.3-1.3-2.1-2.43-4.96-.13s-.66 3.83.6 5.09c1.45 1.45 6.85.08 12.2-5.27C19.54 8.85 20.9 3.45 19.46 2c-1.26-1.25-2.78-3.45-5.08-.6-2.3 2.86-1.17 3.66.13 4.96.9.9-1 3.2-2.97 5.18"
})));
export default SvgPhone;